import types from '../../constants';

const initialState = {
  connecting: false,
  connected: false,
};

const SocketReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.SOCKET_CONNECTING:
      return {
        ...state,
        connecting: true,
        connected: false,
      };
    case types.SOCKET_CONNECTED:
      return {
        ...state,
        connected: true,
        connecting: false,
      };
    case types.SOCKET_DISCONNECTED:
      return {
        ...state,
        connected: false,
        connecting: false,
      };
    default:
      return state;
  }
};

export default SocketReducers;
